import useAppStore from "@/core/stores/app";

const useSizeController = (smallThreshold: number = 768) => {
  const { appWidth, appHeight } = useAppStore();

  const isSmall = appWidth > 0 && appWidth < smallThreshold;
  const isLarge = appWidth > 1280;

  return { innerWidth: appWidth, isSmall, isLarge, innerHeight: appHeight };
};

export default useSizeController;
